/* ALMA · Compra rápida (tema Dwell, 3-oct-2026).
   Añade al carrito desde la portada o desde una fila de productos sin salir de la página:
   tarjeta → «Añadir» → eliges talla → se añade y se abre el carrito.
   La talla nunca viene marcada: la elige la clienta. Sin librerías. Delegación de eventos en document. */
import { CartLinesUpdateEvent } from '@shopify/events';

if (!window.__nbQuick) {
  window.__nbQuick = true;

  const data = (box) => {
    if (!box.__d) {
      try { box.__d = JSON.parse(box.querySelector('[data-nbq-v]').textContent); } catch (e) { box.__d = { s: -1, c: [], v: [] }; }
      box.__opts = box.__d.c.slice();
    }
    return box.__d;
  };

  const say = (box, text, ok) => {
    const m = box.querySelector('[data-nbq-msg]');
    if (m) { m.textContent = text || ''; m.classList.toggle('is-ok', !!ok); }
  };

  // variante disponible para la talla elegida; primero en el color elegido, después en cualquier color
  const pick = (box, size) => {
    const d = data(box);
    if (d.s < 0) return d.v.find((v) => v.o.every((o, i) => o === box.__opts[i])) || d.v[0] || null;
    const cand = d.v.filter((v) => v.o[d.s] === size);
    if (!cand.length) return null;
    return cand.find((v) => v.o.every((o, i) => i === d.s || o === box.__opts[i])) || (box.hasAttribute('data-nbq-strict') ? null : cand[0]);
  };

  // marca como agotadas las tallas sin variante disponible
  const mark = (box) => {
    const d = data(box);
    if (d.s < 0) return;
    const strict = box.hasAttribute('data-nbq-strict');
    box.querySelectorAll('[data-nbq-size]').forEach((b) => {
      const ok = d.v.some((v) => v.o[d.s] === b.dataset.nbqSize && (!strict || v.o.every((o, i) => i === d.s || o === box.__opts[i])));
      b.disabled = !ok;
      b.classList.toggle('is-off', !ok);
      if (!ok && box.__size === b.dataset.nbqSize) { box.__size = null; b.classList.remove('is-on'); }
    });
  };

  const add = (box, v, el) => {
    if (box.__busy) return;
    box.__busy = true;
    el.classList.add('is-busy');
    say(box, 'Añadiendo…');
    const ids = Array.from(document.querySelectorAll('cart-items-component')).map((c) => c.dataset.sectionId).filter(Boolean);
    const deferred = CartLinesUpdateEvent.createPromise();
    document.dispatchEvent(new CartLinesUpdateEvent({ action: 'add', context: 'product', lines: [{ merchandiseId: String(v.i), quantity: 1 }], promise: deferred.promise }));
    const url = (window.Theme && Theme.routes && Theme.routes.cart_add_url ? Theme.routes.cart_add_url : '/cart/add') + '.js';
    fetch(url, {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: v.i, quantity: 1 }], sections: ids.join(','), sections_url: window.location.pathname }),
    })
      .then((r) => r.json())
      .then((res) => {
        if (res.status) { throw new Error(res.description || res.message || 'No se pudo añadir'); }
        return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json()).then((cart) => {
          deferred.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: { items: cart.items, source: 'nb-quick', itemCount: 1, productId: box.dataset.pid, sections: res.sections, didError: false } });
          say(box, 'Añadido a tu carrito', true);
          try { (window.dataLayer = window.dataLayer || []).push({ event: 'alma_quick_add', product_id: box.dataset.pid, variant_id: v.i, placement: box.dataset.place || 'card' }); } catch (e) {}
          // si el carrito no se ha abierto solo, se abre
          setTimeout(() => {
            if (document.querySelector('dialog[open]')) return;
            const dc = document.querySelector('cart-drawer-component');
            if (dc && typeof dc.open === 'function') { try { dc.open(); return; } catch (e) {} }
            const btn = document.querySelector('cart-drawer-component button, [data-testid="cart-drawer-trigger"]');
            if (btn) btn.click();
          }, 900);
        });
      })
      .catch((e) => {
        deferred.resolve({ cart: null, detail: { didError: true, source: 'nb-quick' } });
        say(box, (e && e.message) || 'No se pudo añadir. Inténtalo de nuevo.');
      })
      .finally(() => { box.__busy = false; el.classList.remove('is-busy'); });
  };

  document.addEventListener('click', (ev) => {
    const t = ev.target instanceof Element ? ev.target : null;
    if (!t) return;

    const open = t.closest('[data-nbq-open]');
    if (open) {
      const box = open.closest('[data-nbq]'); if (!box) return;
      const d = data(box);
      if (d.s < 0) { const v = pick(box, null); if (v) add(box, v, open); else say(box, 'Agotado'); return; }
      const panel = box.querySelector('[data-nbq-panel]');
      const show = panel.hasAttribute('hidden');
      document.querySelectorAll('[data-nbq-panel]:not([hidden])').forEach((p) => { if (p !== panel) { p.setAttribute('hidden', ''); const o = p.closest('[data-nbq]').querySelector('[data-nbq-open]'); if (o) o.setAttribute('aria-expanded', 'false'); } });
      panel.toggleAttribute('hidden', !show);
      open.setAttribute('aria-expanded', String(show));
      if (show) mark(box);
      return;
    }

    const col = t.closest('[data-nbq-color]');
    if (col) {
      const box = col.closest('[data-nbq]'); if (!box) return;
      data(box);
      box.__opts[Number(col.dataset.idx)] = col.dataset.nbqColor;
      box.querySelectorAll('[data-nbq-color]').forEach((b) => b.classList.toggle('is-on', b === col));
      const name = box.querySelector('[data-nbq-color-name]'); if (name) name.textContent = col.dataset.nbqColor;
      mark(box); say(box, '');
      return;
    }

    const sz = t.closest('[data-nbq-size]');
    if (sz) {
      const box = sz.closest('[data-nbq]'); if (!box || sz.disabled) return;
      data(box);
      box.__size = sz.dataset.nbqSize;
      box.querySelectorAll('[data-nbq-size]').forEach((b) => b.classList.toggle('is-on', b === sz));
      const wrap = box.querySelector('[data-nbq-sizes]'); if (wrap) wrap.classList.remove('is-missing');
      if (box.hasAttribute('data-nbq-instant')) {
        const v = pick(box, box.__size);
        if (v) add(box, v, sz); else say(box, 'Esa talla está agotada');
      } else { say(box, ''); }
      return;
    }

    const go = t.closest('[data-nbq-add]');
    if (go) {
      const box = go.closest('[data-nbq]'); if (!box) return;
      const d = data(box);
      if (d.s >= 0 && !box.__size) {
        say(box, 'Elige tu talla');
        const wrap = box.querySelector('[data-nbq-sizes]'); if (wrap) { wrap.classList.add('is-missing'); wrap.scrollIntoView({ block: 'center', behavior: 'smooth' }); }
        return;
      }
      const v = pick(box, box.__size);
      if (v) add(box, v, go); else say(box, 'Esa combinación está agotada. Prueba otro color o talla.');
    }
  });

  // tallas agotadas ya marcadas en las cajas de compra visibles al cargar
  const init = () => document.querySelectorAll('[data-nbq][data-nbq-strict]').forEach((b) => mark(b));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
}
